<template>
<div>
    <div class="comment-text ml-2">
        <p class="text-muted text-right">{{hit._source.date | localDateNoHour}}</p>
        <div v-if="hit.hasOwnProperty('highlight')">
            <span v-for="(highlight, index) in hit.highlight.body" :key="'hit-highlight-'+hit._id+'.'+index">
                <strong>...</strong> <span v-html="highlight"></span> <strong>...</strong>
            </span>
        </div>
    </div>
    <div v-if="hit._source.hasOwnProperty('references')">
        <a v-for="(reference, index) in hit._source.references" :key="'hit-reference-'+hit._id+'.'+reference.name+index" class="btn btn-notiblue btn-sm m-1" target="_BLANK" :href="reference.link">
            {{reference.name}}
        </a>
    </div>       
</div>
</template>
 
<script>
export default {
    props: ['hit']
}
</script>